export const extractImgPoster = (providedPath) => {
  let imgSrc;
  return (imgSrc = ` https://image.tmdb.org/t/p/w300/${providedPath}`);
};
